<template>
  <div class="p-6 bg-gray-800/60 rounded-xl min-h-screen">
    <div class="flex justify-between items-center mb-6">
      <h5 class="text-l font-bold text-gray-800 inline-block transition-all duration-500">
        <span
            class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse ml-2">
           انتقال بین انبار
        </span>
      </h5>
      <div class="flex gap-3 mr-3">
        <div class="flex items-center gap-1">
          <searchable-select v-model="filters.store" :options="stores"
                             placeholder="انبار"
                             class="w-32 backdrop-blur-xl z-40"
                             @change="fetchProducts"
          ></searchable-select>

          <span class="rounded-xl p-2 bg-blue-700 text-white text-xs" v-if="filters.product">
            <v-icon @click="resetFilters" class="cursor-pointer ml-3 mr-1" color="white">fa-times</v-icon>
            شناسه محصول : {{ filters.product }}
          </span>

        </div>

      </div>
    </div>
    <div
        v-if="filters.store"
        class="bg-gray-700 bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-lg p-3 mb-2 shadow-sm border border-gray-800">
      <div class="flex flex-wrap items-center gap-2">
        <div class="relative w-32">
          <input
              v-model="filters.name_search"
              placeholder="نام"
              class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <input
              v-model="filters.sku"
              placeholder="SKU"
              class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <input
              v-model="filters.id_in"
              placeholder="شناسه"
              class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <searchable-select v-model="filters.brand_in" :options="brands"
                             placeholder="همه برندها"
                             class="w-32 backdrop-blur-xl z-40"
                             @change="applyFilters"
          ></searchable-select>
        </div>
        <div class="flex gap-1">
          <button
              @click="resetFilters"
              class="p-1.5 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="حذف فیلترها"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>

          <button
              @click="applyFilters"
              class="p-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="اعمال فیلتر"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div
        v-if="filters.store"
        class="z-10 bg-gray-700 bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-lg shadow-sm border border-gray-800 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead class="bg-gray-50 bg-opacity-70">
          <tr>
            <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">SKU</th>
            <th class="p-3 text-[10px] text-white bg-gray-900">محصول</th>
            <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900 "></th>
            <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">حداقل موجودی</th>
            <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">مصرف</th>
            <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">تعداد انتقال</th>
            <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">به انبار</th>
            <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="6" class="p-3 items-center text-center text-[10px] text-white bg-gray-900">
              <div class="flex justify-center items-center gap-2">
                <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                در حال بارگذاری...
              </div>
            </td>
          </tr>
          <tr v-else-if="products.length === 0">
            <td colspan="6" class="p-3 items-center text-center text-[10px] text-white bg-gray-900">
              محصولی یافت نشد
            </td>
          </tr>
          <tr
              v-for="product in products"
              :key="product.id"
              class="border-t border-gray-800 hover:bg-gray-900 transition-colors duration-200"
          >
            <td class=" items-center text-center p-3 font-medium text-[9px] text-white">
              {{ product.sixteen_digit_code || ' بدون کد' }}
            </td>
            <td class="p-3">
              <div class="flex items-center gap-3">
                <div class="relative" v-if="product.image">
                  <img
                      :src="img_source(product.image)"
                      class="w-10 h-10 rounded-lg object-cover border border-gray-200 shadow-sm"
                  >
                </div>
                <div>
                  <div class="text-[9px] font-medium text-white">{{ product.name }}</div>
                  <div class="text-[9px] text-blue-400 text-xs mt-1 flex items-center gap-1 "
                       v-if="product.variation_of">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
                    </svg>
                    {{ product.variation_of.name }}
                  </div>
                </div>
              </div>
            </td>
            <td class="items-center text-center p-3 text-[9px]">
            </td>
            <td class="items-center text-center p-3 text-[13px] text-white">
              <cleave-money currency-unit="عدد" label=" " v-model="product.minimum_inventory"> </cleave-money>
            </td>

            <td class="p-3 text-white">
                <span v-if="product.regular_price > 0">
                  {{product.regular_price | toMoney(0)}}
                </span>
              <span v-else>
                  خارجی
                </span>
            </td>
            <td class="items-center text-center p-3 text-[9px] text-white">
              <input
                  type="number"
                  v-model="product.store_inventory"
                  class="bg-blue-50/80 dark:bg-slate-800/70 w-full border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100
                                  px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-indigo-500"
              />

            </td>
            <td class="items-center text-center p-3 text-[9px] text-white">
              <store-select
                  :with_packing="true"
                  v-if="stores.length > 0"
                  :passed_stores="availableStores"
                  v-model="product.to_store"
              >

              </store-select>
            </td>
            <td class="items-center">
              <button
                  :disabled="submittingId === product.product_id || !product.store_inventory || !product.to_store"
                  @click="handleDone(product)"
                  class="p-2 rounded-lg text-[8px] text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                  :class="submittingId === product.product_id ? 'bg-gray-400' : 'bg-green-600 hover:bg-green-700'">
                <span v-if="submittingId !== product.product_id">ثبت انتقال</span>
                <span v-else class="inline-flex items-center gap-2">
                  <svg class="animate-spin h-4 w-4" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                  </svg>
                  در حال ثبت...
                </span>
              </button>

            </td>

          </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="p-4 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
        <div class="text-sm text-gray-600">
          نمایش {{ (currentPage - 1) * itemsPerPage + 1 }} تا
          {{ Math.min(currentPage * itemsPerPage, totalProducts) }} از
          {{ totalProducts }} محصول
        </div>
        <div class="flex gap-1">
          <button
              @click="prevPage"
              :disabled="currentPage === 1"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage === 1 }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
          <button
              v-for="page in visiblePages"
              :key="page"
              @click="goToPage(page)"
              class="p-2 text-center border border-gray-200 rounded-full transition-colors duration-200"
              :class="{
              'bg-gradient-to-r from-blue-500/60 to-blue-600/50 text-white shadow-md': page === currentPage,
              'bg-white bg-opacity-50 hover:bg-gray-50': page !== currentPage,
              'cursor-default': page === '...'
            }"
              :disabled="page === '...'"
          >
            {{ page }}
          </button>
          <button
              @click="nextPage"
              :disabled="currentPage * itemsPerPage >= totalProducts"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage * itemsPerPage >= totalProducts }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div v-if="!filters.store"
         class="p-6 text-center text-gray-500 text-sm">
      لطفاً ابتدا انبار مبدأ را انتخاب کنید
    </div>

    <transition name="fade-zoom">
      <div v-if="alert.show"
           class="fixed inset-0 z-[100] flex items-center justify-center"
           tabindex="0"
           @keydown.esc="clearAlert">
        <div class="absolute inset-0 bg-black/40 backdrop-blur-[2px]"
             @click.self="clearAlert"></div>

        <div class="relative w-[92%] max-w-md rounded-2xl border p-5 shadow-xl"
             :class="alert.type==='success'
             ? 'bg-white border-green-200'
             : 'bg-white border-red-200'">
          <div class="flex items-start gap-3">
            <div class="shrink-0 rounded-full p-2"
                 :class="alert.type==='success'
                 ? 'bg-green-100 text-green-700'
                 : 'bg-red-100 text-red-700'">
              <svg v-if="alert.type==='success'" class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"/>
              </svg>
              <svg v-else class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11 7h2v6h-2z"/>
                <path d="M11 15h2v2h-2z"/>
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
              </svg>
            </div>

            <div class="text-sm leading-6 text-gray-800">{{ alert.message }}</div>
          </div>

          <div class="mt-4 flex justify-end">
            <button @click="clearAlert"
                    class="rounded-lg px-3 py-1.5 text-sm text-white"
                    :class="alert.type==='success'
                    ? 'bg-green-600 hover:bg-green-700'
                    : 'bg-red-600 hover:bg-red-700'">
              تایید
            </button>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import PackingStoreHandle from "@/modules/store_handle/PackingStoreHandle";
import StoreSelect from "@/components/selects/StoreSelect";
import ProductsSelect from "@/components/selects/ProductSelect";
import SearchableSelect from "@/components/selects/SearchableSelect";
import CleaveMoney from "@/components/mcomponents/cleave/Money";

export default {
  name: 'StoreToStoreTransfer',
  components: {CleaveMoney, ProductsSelect, StoreSelect, PackingStoreHandle, SearchableSelect},
  data() {
    return {
      submittingId: null,
      alert: {show: false, type: 'success', message: '', actions: null},
      rowErrors: {},
      showNotification: false,
      showQuickEdit: false,
      selectedProduct: null,
      selectedProductId: null,
      loading: true,
      products: [],
      totalProducts: 0,
      currentPage: 1,
      activePricing: [],
      stores: [],
      itemsPerPage: 20,
      filters: {
        id_in: '',
        product: '',
        store: null,
        min_inventory: '',
        name_search: '',
        sku: '',
        search_value: '',
        brand_in: '',
      },
      categories: [],
      brands: [],
      currencies: [],
      productSelected: null,
      showProductStoreHandle: false
    }
  },
  computed: {
    availableStores() {
      return this.stores.filter(store => store.id !== this.filters.store)
    },
    visiblePages() {
      const totalPages = Math.ceil(this.totalProducts / this.itemsPerPage)
      const range = 1
      const pages = []

      pages.push(1)

      if (this.currentPage - range > 2) {
        pages.push('...')
      }

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }

      if (totalPages > 1) {
        pages.push(totalPages)
      }

      return pages
    },
  },
  methods: {
    isActive(product) {
      return this.activePricing.some(p => p === product);
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data
        }
      })
    },
    fetchStores() {
      this.request({
        url: this.endpoint(`main/store`),
        method: "get",
        success: data => {
          this.stores = data
        }
      })
    },
    showAlert(type, msg, actions = null) {
      this.alert = {show: true, type, message: msg, actions};
      if (type === 'success') {
        setTimeout(() => this.clearAlert(), 3000); // فقط برای success بسته شود
      }
    },
    clearAlert() {
      this.alert.show = false;
    },
    setRowError(pid, msg) {
      // Vue 3 friendly
      this.rowErrors = {...this.rowErrors, [pid]: msg};
    },
    clearRowError(pid) {
      const copy = {...this.rowErrors};
      delete copy[pid];
      this.rowErrors = copy;
    },
    handleDone(product) {
      this.clearAlert();
      this.clearRowError(product.product_id);

      if (!this.filters.store) {
        this.showAlert('error', 'لطفاً انبار مبدأ را انتخاب کنید');
        return;
      }
      if (!product.to_store) {
        this.showAlert('error', 'انبار مقصد را انتخاب کنید');
        return;
      }

      const qty = Number(product.store_inventory || 0);
      if (!qty || qty <= 0) {
        this.setRowError(product.product_id, 'تعداد انتقال نامعتبر است');
        return;
      }

      this.submittingId = product.product_id;

      this.request({
        url: this.endpoint('store_handle/storeToStoreTransfer/transfer'),
        method: 'post',
        data: {
          from_store_id: this.filters.store,
          to_store_id: product.to_store,
          product_id: product.product_id,
          minimum : product.minimum_inventory,
          quantity: qty,
          note: 'انتقال بین انبار'
        },
        headers: {'Idempotency-Key': crypto.randomUUID?.() || Math.random().toString(36).slice(2)},
        success: () => {
          this.showAlert('success', 'انتقال با موفقیت ثبت شد ✅');
          this.submittingId = null;
          this.fetchProducts();
        },
        error: (err) => {
          const data = err?.response?.data;
          const msg = data?.detail
              || Object.values(data || {}).flat().join('، ')
              || 'خطایی رخ داد در ثبت انتقال ❌';
          this.showAlert('error', msg);
          this.setRowError(product.product_id, msg);
          this.submittingId = null;
        }
      });
    },
    fetchProducts() {
      this.loading = true

      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters
      }

      Object.keys(params).forEach(key => {
        if (params[key] === '') {
          delete params[key]
        }
      })

      this.request({
        url: this.endpoint('store_handle/storeToStoreInventoryList'),
        method: 'get',
        params,
        success: (data) => {
          this.products = []
          for (let item of data.results) {
            this.products.push(
                {
                  product_id: item.product_id,
                  image: item.image,
                  product: item.id,
                  sixteen_digit_code: item.sixteen_digit_code,
                  name: item.name,
                  variation_of: item.variation_of,
                  product_type: item.product_type,
                  store_inventory: item.inventory,
                  regular_price: item.regular_price,
                  minimum_inventory: item.minimum,
                }
            )
          }
          this.totalProducts = data.count
          this.loading = false
        },
        error: () => {
          this.loading = false
          this.totalProducts = 0;
        }
      })
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchProducts()
    },

    resetFilters() {
      this.filters = {
        id_in: '',
        product: '',
        store: 5,
        min_inventory: '',
        name_search: '',
        sku: '',
        search_value: '',
        brand_in: '',
      }
      this.applyFilters()
    },

    refreshProducts() {
      this.fetchProducts()
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchProducts()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalProducts) {
        this.currentPage++
        this.fetchProducts()
      }
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchProducts()
      }
    },
    productStoreHandle(product) {
      this.selectedProduct = product
      this.showProductStoreHandle = true

    },
    active(product) {
      const index = this.activePricing.indexOf(product);
      if (index > -1) {
        this.activePricing.splice(index, 1);
      } else {
        this.activePricing.push(product);
      }
    },
    calculate_discount(price, discount) {
      return price - (price / 100 * discount)
    },
    closeProductStoreHandle() {
      this.selectedProduct = null
      this.showProductStoreHandle = false
    },


  },
  watch: {
    'filters.store'(val) {
      this.products = this.products.map(p => ({...p, to_store: null}))
    }
  },

  mounted() {
    if (this.$route.query.product) {
      this.filters.product = this.$route.query.product
    }
    if (this.$route.query.store_in) {
      this.filters.store = this.$route.query.store_in
    }
    this.fetchBrands()
    this.fetchProducts()
    this.fetchStores()
  }
}
</script>

<style>
/* RTL support */
body {
  direction: rtl;
  text-align: right;
}

/* Glass morphism effect */
.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

/* Neumorphism effect */
.neumorphism {
  border-radius: 16px;
  background: #f0f0f0;
  box-shadow: 8px 8px 16px #d9d9d9,
  -8px -8px 16px #ffffff;
}

/* Smooth transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.glass-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.bg-secondary {
  background-color: #424242;
}

.fade-zoom-enter-active,
.fade-zoom-leave-active {
  transition: all .18s ease;
}

.fade-zoom-enter-from,
.fade-zoom-leave-to {
  opacity: 0;
  transform: scale(.96);
}
</style>